module.exports = __webpack_public_path__ + "img/1.b7ec60ca.png";